export const selectOrderItems = (item, prevItems) => {
	const inPrev = prevItems.some((i) => i.id === item.id);

	if (inPrev) {
		return prevItems.filter((i) => i.id !== item.id);
	}

	return [...prevItems, item];
};
